import { Component, Input, OnInit } from '@angular/core';
import { PhotoService } from '../services/photo.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environment';
import { MemoryViewerComponent } from '../memory-viewer/memory-viewer.component';
import MainScene from '../Scenes/MainScene';
import BaseLevelScene from '../Scenes/BaseLevelScene';

@Component({
  selector: 'app-photo-container',
  templateUrl: './photo-container.component.html',
  styleUrls: ['./photo-container.component.scss'],
})
export class PhotoContainerComponent  implements OnInit {

  @Input() photoSrc: string;
  @Input() filePath: string;
  @Input() privateDisplay: boolean;

  // display the number of likes the photo has
  likes$ = new BehaviorSubject<number>(0);
  scene: MainScene | BaseLevelScene;
  photoService: PhotoService;

  constructor(private http: HttpClient) {
    this.photoService = new PhotoService(http);
   }

  ngOnInit() {
    this.http.get(`${environment.REST_API}/metadata?s3Path=${this.filePath}`).subscribe({
      next: data => {
          this.likes$.next(data["likes"]);
      },
      error: error => {
          console.error('There was an error retrieving the photo likes!', error);
      }
    });
  }

  photoClicked(){
    MemoryViewerComponent.openModal(this.filePath, null, false);
  }

  async deletePhoto(){
    const deleted: boolean = await this.photoService.deleteImage(this.filePath);
    console.log("Deleted: ", deleted);
  }

  async likePhoto(){
    console.log("filePath: ", this.filePath);
    const postBody = JSON.stringify({s3Path: this.filePath});
    // Add to end of post request
    this.http.post(`${environment.REST_API}/like`, postBody).subscribe({
      next: data => {
          this.likes$.next(data["likes"]);
      },
      error: error => {
          console.error('There was an error!', error);
      }
    });
  }

}
